// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBXjr_CtWmD2aC45RZsxcMS8Ct5F5ugwQ4",
  authDomain: "generic-webapp-a1347.firebaseapp.com",
  projectId: "generic-webapp-a1347",
  storageBucket: "generic-webapp-a1347.appspot.com",
  messagingSenderId: "929101848384",
  appId: "1:929101848384:web:a4d5ebe3eb8f2946bc64a5"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const database = getFirestore(app);
export const auth = getAuth(app);
